/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SuccessorColourUpdateRequestDto } from '../models';
// @ts-ignore
import type { SuccessorCommentUpdateRequestDto } from '../models';
// @ts-ignore
import type { SuccessorExCommUpdateRequestDto } from '../models';
// @ts-ignore
import type { SuccessorExclamationMarkUpdateRequestDto } from '../models';
// @ts-ignore
import type { SuccessorExpatUpdateRequestDto } from '../models';
/**
 * SuccessorPositionStateRestApi - axios parameter creator
 * @export
 */
export const SuccessorPositionStateRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Override successor colour for the given position state
         * @param {string} employeeId 
         * @param {SuccessorColourUpdateRequestDto} successorColourUpdateRequestDto Successor colour update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorColour: async (employeeId: string, successorColourUpdateRequestDto: SuccessorColourUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateSuccessorColour', 'employeeId', employeeId)
            // verify required parameter 'successorColourUpdateRequestDto' is not null or undefined
            assertParamExists('updateSuccessorColour', 'successorColourUpdateRequestDto', successorColourUpdateRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/colour-update`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(successorColourUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update successor comment for the given position state
         * @param {string} employeeId 
         * @param {SuccessorCommentUpdateRequestDto} successorCommentUpdateRequestDto Successor comment update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorComment: async (employeeId: string, successorCommentUpdateRequestDto: SuccessorCommentUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateSuccessorComment', 'employeeId', employeeId)
            // verify required parameter 'successorCommentUpdateRequestDto' is not null or undefined
            assertParamExists('updateSuccessorComment', 'successorCommentUpdateRequestDto', successorCommentUpdateRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/comment-update`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(successorCommentUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Override ex-comms
         * @param {string} employeeId 
         * @param {SuccessorExCommUpdateRequestDto} successorExCommUpdateRequestDto Successor exComm update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorExComm: async (employeeId: string, successorExCommUpdateRequestDto: SuccessorExCommUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateSuccessorExComm', 'employeeId', employeeId)
            // verify required parameter 'successorExCommUpdateRequestDto' is not null or undefined
            assertParamExists('updateSuccessorExComm', 'successorExCommUpdateRequestDto', successorExCommUpdateRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/excomm-update`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(successorExCommUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Override exclamation mark for the given position state
         * @param {string} employeeId 
         * @param {SuccessorExclamationMarkUpdateRequestDto} successorExclamationMarkUpdateRequestDto Successor exclamation mark update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorExclamationMark: async (employeeId: string, successorExclamationMarkUpdateRequestDto: SuccessorExclamationMarkUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateSuccessorExclamationMark', 'employeeId', employeeId)
            // verify required parameter 'successorExclamationMarkUpdateRequestDto' is not null or undefined
            assertParamExists('updateSuccessorExclamationMark', 'successorExclamationMarkUpdateRequestDto', successorExclamationMarkUpdateRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/exclamation-mark-update`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(successorExclamationMarkUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Override expats
         * @param {string} employeeId 
         * @param {SuccessorExpatUpdateRequestDto} successorExpatUpdateRequestDto Successor expat update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorExpat: async (employeeId: string, successorExpatUpdateRequestDto: SuccessorExpatUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateSuccessorExpat', 'employeeId', employeeId)
            // verify required parameter 'successorExpatUpdateRequestDto' is not null or undefined
            assertParamExists('updateSuccessorExpat', 'successorExpatUpdateRequestDto', successorExpatUpdateRequestDto)
            const localVarPath = `/api/v2/successions/employees/{employeeId}/expat-update`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(successorExpatUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuccessorPositionStateRestApi - functional programming interface
 * @export
 */
export const SuccessorPositionStateRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuccessorPositionStateRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Override successor colour for the given position state
         * @param {string} employeeId 
         * @param {SuccessorColourUpdateRequestDto} successorColourUpdateRequestDto Successor colour update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuccessorColour(employeeId: string, successorColourUpdateRequestDto: SuccessorColourUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuccessorColour(employeeId, successorColourUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessorPositionStateRestApi.updateSuccessorColour']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update successor comment for the given position state
         * @param {string} employeeId 
         * @param {SuccessorCommentUpdateRequestDto} successorCommentUpdateRequestDto Successor comment update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuccessorComment(employeeId: string, successorCommentUpdateRequestDto: SuccessorCommentUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuccessorComment(employeeId, successorCommentUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessorPositionStateRestApi.updateSuccessorComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Override ex-comms
         * @param {string} employeeId 
         * @param {SuccessorExCommUpdateRequestDto} successorExCommUpdateRequestDto Successor exComm update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuccessorExComm(employeeId: string, successorExCommUpdateRequestDto: SuccessorExCommUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuccessorExComm(employeeId, successorExCommUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessorPositionStateRestApi.updateSuccessorExComm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Override exclamation mark for the given position state
         * @param {string} employeeId 
         * @param {SuccessorExclamationMarkUpdateRequestDto} successorExclamationMarkUpdateRequestDto Successor exclamation mark update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuccessorExclamationMark(employeeId: string, successorExclamationMarkUpdateRequestDto: SuccessorExclamationMarkUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuccessorExclamationMark(employeeId, successorExclamationMarkUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessorPositionStateRestApi.updateSuccessorExclamationMark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Override expats
         * @param {string} employeeId 
         * @param {SuccessorExpatUpdateRequestDto} successorExpatUpdateRequestDto Successor expat update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSuccessorExpat(employeeId: string, successorExpatUpdateRequestDto: SuccessorExpatUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSuccessorExpat(employeeId, successorExpatUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessorPositionStateRestApi.updateSuccessorExpat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuccessorPositionStateRestApi - factory interface
 * @export
 */
export const SuccessorPositionStateRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuccessorPositionStateRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Override successor colour for the given position state
         * @param {string} employeeId 
         * @param {SuccessorColourUpdateRequestDto} successorColourUpdateRequestDto Successor colour update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorColour(employeeId: string, successorColourUpdateRequestDto: SuccessorColourUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuccessorColour(employeeId, successorColourUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update successor comment for the given position state
         * @param {string} employeeId 
         * @param {SuccessorCommentUpdateRequestDto} successorCommentUpdateRequestDto Successor comment update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorComment(employeeId: string, successorCommentUpdateRequestDto: SuccessorCommentUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuccessorComment(employeeId, successorCommentUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Override ex-comms
         * @param {string} employeeId 
         * @param {SuccessorExCommUpdateRequestDto} successorExCommUpdateRequestDto Successor exComm update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorExComm(employeeId: string, successorExCommUpdateRequestDto: SuccessorExCommUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuccessorExComm(employeeId, successorExCommUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Override exclamation mark for the given position state
         * @param {string} employeeId 
         * @param {SuccessorExclamationMarkUpdateRequestDto} successorExclamationMarkUpdateRequestDto Successor exclamation mark update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorExclamationMark(employeeId: string, successorExclamationMarkUpdateRequestDto: SuccessorExclamationMarkUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuccessorExclamationMark(employeeId, successorExclamationMarkUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Override expats
         * @param {string} employeeId 
         * @param {SuccessorExpatUpdateRequestDto} successorExpatUpdateRequestDto Successor expat update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuccessorExpat(employeeId: string, successorExpatUpdateRequestDto: SuccessorExpatUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSuccessorExpat(employeeId, successorExpatUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuccessorPositionStateRestApi - interface
 * @export
 * @interface SuccessorPositionStateRestApi
 */
export interface SuccessorPositionStateRestApiInterface {
    /**
     * 
     * @summary Override successor colour for the given position state
     * @param {string} employeeId 
     * @param {SuccessorColourUpdateRequestDto} successorColourUpdateRequestDto Successor colour update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApiInterface
     */
    updateSuccessorColour(employeeId: string, successorColourUpdateRequestDto: SuccessorColourUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update successor comment for the given position state
     * @param {string} employeeId 
     * @param {SuccessorCommentUpdateRequestDto} successorCommentUpdateRequestDto Successor comment update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApiInterface
     */
    updateSuccessorComment(employeeId: string, successorCommentUpdateRequestDto: SuccessorCommentUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Override ex-comms
     * @param {string} employeeId 
     * @param {SuccessorExCommUpdateRequestDto} successorExCommUpdateRequestDto Successor exComm update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApiInterface
     */
    updateSuccessorExComm(employeeId: string, successorExCommUpdateRequestDto: SuccessorExCommUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Override exclamation mark for the given position state
     * @param {string} employeeId 
     * @param {SuccessorExclamationMarkUpdateRequestDto} successorExclamationMarkUpdateRequestDto Successor exclamation mark update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApiInterface
     */
    updateSuccessorExclamationMark(employeeId: string, successorExclamationMarkUpdateRequestDto: SuccessorExclamationMarkUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Override expats
     * @param {string} employeeId 
     * @param {SuccessorExpatUpdateRequestDto} successorExpatUpdateRequestDto Successor expat update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApiInterface
     */
    updateSuccessorExpat(employeeId: string, successorExpatUpdateRequestDto: SuccessorExpatUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * SuccessorPositionStateRestApi - object-oriented interface
 * @export
 * @class SuccessorPositionStateRestApi
 * @extends {BaseAPI}
 */
export class SuccessorPositionStateRestApi extends BaseAPI implements SuccessorPositionStateRestApiInterface {
    /**
     * 
     * @summary Override successor colour for the given position state
     * @param {string} employeeId 
     * @param {SuccessorColourUpdateRequestDto} successorColourUpdateRequestDto Successor colour update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApi
     */
    public updateSuccessorColour(employeeId: string, successorColourUpdateRequestDto: SuccessorColourUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessorPositionStateRestApiFp(this.configuration).updateSuccessorColour(employeeId, successorColourUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update successor comment for the given position state
     * @param {string} employeeId 
     * @param {SuccessorCommentUpdateRequestDto} successorCommentUpdateRequestDto Successor comment update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApi
     */
    public updateSuccessorComment(employeeId: string, successorCommentUpdateRequestDto: SuccessorCommentUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessorPositionStateRestApiFp(this.configuration).updateSuccessorComment(employeeId, successorCommentUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Override ex-comms
     * @param {string} employeeId 
     * @param {SuccessorExCommUpdateRequestDto} successorExCommUpdateRequestDto Successor exComm update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApi
     */
    public updateSuccessorExComm(employeeId: string, successorExCommUpdateRequestDto: SuccessorExCommUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessorPositionStateRestApiFp(this.configuration).updateSuccessorExComm(employeeId, successorExCommUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Override exclamation mark for the given position state
     * @param {string} employeeId 
     * @param {SuccessorExclamationMarkUpdateRequestDto} successorExclamationMarkUpdateRequestDto Successor exclamation mark update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApi
     */
    public updateSuccessorExclamationMark(employeeId: string, successorExclamationMarkUpdateRequestDto: SuccessorExclamationMarkUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessorPositionStateRestApiFp(this.configuration).updateSuccessorExclamationMark(employeeId, successorExclamationMarkUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Override expats
     * @param {string} employeeId 
     * @param {SuccessorExpatUpdateRequestDto} successorExpatUpdateRequestDto Successor expat update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuccessorPositionStateRestApi
     */
    public updateSuccessorExpat(employeeId: string, successorExpatUpdateRequestDto: SuccessorExpatUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return SuccessorPositionStateRestApiFp(this.configuration).updateSuccessorExpat(employeeId, successorExpatUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

